import { Data } from 'effect';

export class WSConnectionError extends Data.TaggedError('WSConnectionError')<{
  readonly message: string;
  readonly originalError: unknown;
}> {}
